// --------------------------------------------------------------
// Created On: 2022-10-24
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import styles from "./FilteredTableContainer.module.scss";

// Table with the option to filter results.
export default function FilteredTableContainer(props: Props): Component {
  // Show children if there is content and no filter bar, or there is filter a bar and content matches the filter.
  const showChildren =
    props.hasContent && ((props.showFilterInput && props.hasFilteredContent) || !props.showFilterInput);
  return (
    <div data-test="filtered-table-container" className={`${styles.body} table-responsive mb-0 pb-0`}>
      <div className={styles.header}>
        <div className="row pt-2 pb-4 px-2 mx-0">
          {/* Title */}
          <div className="col-6">
            <span data-test="filtered-table-title">{props.title}</span>
          </div>
          {/* Offset. */}
          <div className="col-1 col-lg-2" />
          {/* Header Button */}
          {props.headerButton !== undefined && (
            <Fragment>
              {props.showFilterInput ? props.headerButton : <div className="col pt-2">{props.headerButton}</div>}
            </Fragment>
          )}
          {/* Filter bar. */}
          {props.showFilterInput && (
            <div className={`col-4 col-lg-3 ${props.headerButton === undefined ? "w-100" : ""}`}>
              <div className="input-group pt-1">
                <input
                  data-test="filtered-table-filter-input"
                  type="search"
                  className="form-control rounded"
                  placeholder={props.filterPrompt}
                  value={props.filter}
                  onChange={(e) => props.onChangeFilter(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {showChildren && props.children}

      {!props.hasContent && (
        <div className={`${styles.info} pt-5 pb-4 px-4`}>
          <h5 className="mb-4">No {props.pluralContentType.toLowerCase()} found.</h5>
        </div>
      )}

      {props.hasContent && props.showFilterInput && !props.hasFilteredContent && (
        <div className={`${styles.info} pt-5 pb-4 px-4`}>
          <h5 className="mb-4">No {props.pluralContentType.toLowerCase()} match the filter.</h5>
        </div>
      )}
    </div>
  );
}

interface Props {
  title: string;
  filterPrompt: string;
  filter: string;
  hasContent: boolean;
  hasFilteredContent: boolean;
  showFilterInput: boolean;
  pluralContentType: string;
  headerButton?: Component;
  onChangeFilter: (filter: string) => void;
  children?: Children;
}
